import React, { useCallback, useState, useEffect } from 'react';
import { StyleSheet, View, Text, Button, useColorScheme, StatusBar, Platform, Alert } from 'react-native';
import { useTranslation } from 'react-i18next';
import * as secureStorage from './src/services/secureStorage';

import FirebaseContainer from './src/Firebase/FirebaseContainer'

import FlashMessage from "react-native-flash-message";
import { useFonts } from 'expo-font';

import { showMessage } from "react-native-flash-message";

import { AuthProvider } from './src/context/authContext';
import { AccountProvider } from './src/context/accountContext';
import { SettingsProvider } from './src/context/settingsContext';
import { UserRoleProvider } from './src/context/userroleContext';
import NavContainer from './src/navigation/NavContainer';

import { Provider } from 'react-native-paper';
import { MenuProvider } from 'react-native-popup-menu';
import { checkForUpdate } from './src/CheckForUpdate/checkForUpdate';
// import { initializeSslPinning } from 'react-native-ssl-public-key-pinning';

// import { HeaderShownContext } from '@react-navigation/elements';   // might be needed to fix flickering issue with top header
import { SafeAreaProvider } from 'react-native-safe-area-context';    // fixes bug with bottom tab nav and top header flickering on first render
import { msalInstance } from './authConfig';
import { MsalProvider } from '@azure/msal-react';
// Two navigation one for logged in and one for login and registering
// Check safeareaview for IOS? 
// https://reactnavigation.org/docs/auth-flow/
import { store, persistor } from './src/state/store';

// ! IMPORTANT THIS MUST BE THE LAST IMPORT IN THIS FILE
import './src/constants/IMLocalize';

const STYLES = ['default', 'dark-content', 'light-content'];
const TRANSITIONS = ['fade', 'slide', 'none'];

export default function App() {

  const { t } = useTranslation();
  const [storageReady, setStorageReady] = useState(Platform.OS === 'web');
  const [storageFailed, setStorageFailed] = useState(false);
  const initializeStorage = useCallback(async () => {
    setStorageFailed(false);
    try {
      await secureStorage.migrateStorage();
      setStorageReady(true);
    } catch (error) {
      console.error('Secure storage migration failed', error);
      setStorageFailed(true);
    }
  }, []);

  useEffect(() => {
    if (Platform.OS !== 'web') initializeStorage();
  }, [initializeStorage]);

  let colorScheme = useColorScheme();
  const [hidden, setHidden] = useState(false);
  const [statusBarStyle, setStatusBarStyle] = useState(colorScheme === 'light' ? STYLES[1] : STYLES[2],);
  const [statusBarTransition, setStatusBarTransition] = useState(TRANSITIONS[0],)
  const [fontsLoaded, fontError] = useFonts({
    'Roboto-Medium': require('./assets/fonts/Roboto-Medium.ttf'),
    Ionicons: require('@react-native-vector-icons/ionicons/fonts/Ionicons.ttf'),
    MaterialDesignIcons: require('@react-native-vector-icons/material-design-icons/fonts/MaterialDesignIcons.ttf'),
  });

  useEffect(() => {
    //* SSL Pinning for secure access to the API
    // const onSSLPinning = async () => {
    //   // SSL Pinning with public key å
    //   await initializeSslPinning({
    //     'test.oasys.com.cy': {
    //       includeSubdomains: true,
    //       publicKeyHashes: [
    //         'VotYZ66J4GMXKaZGUJIKohAsyGID/hKdbBoWUO7Csz0=',
    //         'hIBbkSty62Y4PvvLLkYxEHhqoAK2s9JgMSFHh6HeR60='
    //       ],
    //     },
    //   });
    // }
    if (Platform.OS !== 'web') {
      checkForUpdate().catch(
        (error) => {
          showMessage({
            message: error,
            type: "danger",
            duration: 10000,
          })
        }
      )
    }



    //* Skip SSL pinning on web version of the applications
    // if (Platform.OS !== 'web') {
    //   // Call Async Function
    //   onSSLPinning()
    //     // make sure to catch any error
    //     .catch(console.error);
    // }

  }, [])

  const onLayoutRootView = useCallback(async () => {
    if (fontsLoaded) {
      // await SplashScreen.hideAsync();
    }
  }, [fontsLoaded]);

  if (fontError) {
    throw fontError;
  }
  if (storageFailed) {
    return (
      <SafeAreaProvider>
        <View style={style.container}>
          <Text>{t('common:secureStorageError')}</Text>
          <Button title={t('common:secureStorageRetry')} onPress={initializeStorage} />
        </View>
      </SafeAreaProvider>
    );
  }
  if (!fontsLoaded || !storageReady) {
    return null;
  }
  const Main = () => {
    return (<View onLayout={onLayoutRootView} style={style.container}>
      <StatusBar
        animated={true}
        backgroundColor={colorScheme === 'light' ? '#FFFFFF' : '#121212'}
        barStyle={statusBarStyle}
        showHideTransition={statusBarTransition}
        hidden={hidden}
      />
      <MenuProvider
        backHandler={true}
        customStyles={{
          backdrop: {
            backgroundColor: '#4f4f4f',
            opacity: 0.6
          }
        }}
      >
        {/* Solves bug with header height flickering on first render. Left here just in case it is needed. */}
        {/* <HeaderShownContext.Provider value={true}> */}
        <NavContainer />
        <FirebaseContainer />
        <FlashMessage
          position={Platform.OS === 'web' ? 'top' : 'bottom'}
          duration={5000} style={{
            width: Platform.OS === 'web' ? '50%' : '100%',
            alignSelf: 'center', borderRadius: Platform.OS === 'web' ? 5 : 0,
            elevation: 10200, zIndex: 1000
          }} titleStyle={{ fontSize: Platform.OS === 'web' ? 18 : 16, }} />
        {/* </HeaderShownContext.Provider> */}
      </MenuProvider>
    </View>)
  }

  return (
    <SafeAreaProvider>
      <Provider store={store}>
        <AuthProvider>
          <AccountProvider>
            <UserRoleProvider>
              <SettingsProvider>
                {Platform.OS === 'web' ?
                  <MsalProvider instance={msalInstance}>
                    <Main />
                  </MsalProvider>
                  :
                  <Main />
                }
              </SettingsProvider>
            </UserRoleProvider>
          </AccountProvider>
        </AuthProvider>
      </Provider>
    </SafeAreaProvider>
  )
}


// Flex defines how much of the screen this is going to take
const style = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
  },
});
